module.exports = __webpack_public_path__ + "static/media/body1.91d2960c.jpg";